import React from 'react'

class FancySlider extends React.Component {
    handleChangeEvent (event) {
        event.preventDefault()
        const value = event.currentTarget.value
        this.props.setValue(value)
    }

    render () {
        return (
            <div className='fancy-slider'>
                <input
                    type='range'
                    className='slider'
                    name={this.props.name}
                    value={this.props.value}
                    min={this.props.min}
                    max={this.props.max}
                    step={this.props.step}
                    onChange={this.handleChangeEvent.bind(this)}
                />
                <output className='py-3 font-larger'>
                    <span className='bold color-lime' style={{ fontSize: '30px' }} dangerouslySetInnerHTML={{ __html: this.props.display(this.props.value) }} />
                </output>
            </div>
        )
    }
}

export default FancySlider



// WEBPACK FOOTER //
// ./resources/js/elements/FancySlider.js